import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  input: {
    marginBottom: '1rem',
    border: 'none',
    height: '17px',
    borderBottom: '1px solid #8F8F8F',
    width: '100%',
    padding: '0',
    paddingBottom: '8px',
    outline: 'none',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&::placeholder': {
      fontSize: theme.size.sm,
      color: '#8F8F8F !important',
      opacity: '0.5'
    }
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  button: {
    width: 'fit-content',
    paddingBlock: 0,
    fontSize: theme.size.sm
  }
}))

export default useStyles
